import {LocalStorageKey} from "../../types/local-storage/local-storage-key";

export const setLocalStorageAccessToken = (accessToken: string) => {
    localStorage.setItem(LocalStorageKey.AccessToken, accessToken);
};

export const clearLocalStorageAccessToken = () => {
    localStorage.removeItem(LocalStorageKey.AccessToken);
};
